import { returnMovieGenres } from "./MovieSearch";
import { Movie } from "./types";

class StateManager {
  private currentPages;
  private currentlyViewingSearchResults;
  private searchString;
  private genres;
  private movies;

  constructor(
    initialPages = { default: 1, search: 1 },
    initialQuery: string = "",
    initialViewingSearchResults: boolean = false,
    genres: Map<number, string> = new Map(),
    initialMovies: Movie[] = [],
  ) {
    this.currentPages = initialPages;
    this.searchString = initialQuery;
    this.currentlyViewingSearchResults = initialViewingSearchResults;
    this.genres = genres;
    this.movies = initialMovies;
  }

  getCurrentSearchPage(): number {
    return this.currentPages["search"];
  }

  getCurrentDefaultPage(): number {
    return this.currentPages["default"];
  }

  getGenres(): Map<number, string> {
    return this.genres;
  }

  getCurrentlyViewingSearchResults() {
    return this.currentlyViewingSearchResults;
  }

  getSearchString() {
    return this.searchString;
  }

  getMovies() {
    return [...this.movies];
  }

  incrementPage(mode: "default" | "search") {
    this.currentPages[mode] += 1;
  }

  resetPage(mode: "default" | "search") {
    this.currentPages[mode] = 1;
  }

  async setGenres() {
    const allGenres = await returnMovieGenres();
    this.genres = new Map(
      allGenres.genres.map((genre) => [genre.id, genre.name]),
    );
  }

  setViewingSearchResults(viewing: boolean) {
    this.currentlyViewingSearchResults = viewing;
  }

  setSearchString(string: string) {
    this.searchString = string;
  }

  addToMovies(movies: Movie[]) {
    const currentIds = new Set(this.movies.map((movie) => movie.id));
    for (const newMovie of movies) {
      if (!currentIds.has(newMovie.id)) {
        this.movies.push(newMovie);
        currentIds.add(newMovie.id);
      }
    }
  }

  clearMovies() {
    this.movies = [];
  }
}

export const appState = new StateManager();
